"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertReactionEmoji = exports.reactionEmojis = exports.ReactionEmoji = exports.REACTION_EMOJI_COOLDOWN = void 0;
const validate_1 = require("../utils/validate");
/**
 * How long the user must wait between sending emojis.
 */
exports.REACTION_EMOJI_COOLDOWN = 8000; // milliseconds
var ReactionEmoji;
(function (ReactionEmoji) {
    ReactionEmoji["HUG"] = "HUG";
    ReactionEmoji["EAR"] = "EAR";
    ReactionEmoji["CLAP"] = "CLAP";
    ReactionEmoji["LIKE"] = "LIKE";
    ReactionEmoji["HEARTS"] = "HEARTS";
})(ReactionEmoji = exports.ReactionEmoji || (exports.ReactionEmoji = {}));
exports.reactionEmojis = Object.values(ReactionEmoji);
function assertReactionEmoji(value, valueName) {
    if (exports.reactionEmojis.includes(value)) {
        return value;
    }
    throw validate_1.typeError('ReactionEmoji', value, valueName);
}
exports.assertReactionEmoji = assertReactionEmoji;
//# sourceMappingURL=ReactionEmoji.js.map